import React, { Component } from 'react';
import './style.css';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {logIn, setMessageFail} from '../../actions/login';

class LogIn extends Component {
  constructor(props){
    super(props)

    this.state={
      email :"",
      password:"",
    }
    this.onChange = this.onChange.bind(this);
    this.login = this.login.bind(this);
  }

  onChange(e){
  this.setState({[e.target.name]: e.target.value});
  }

  login(){
    let logInData = {}
    logInData.email =  this.state.email;
    logInData.password =  this.state.password;
   this.props.dispatch(logIn(logInData));
   this.props.history.push('/');
  }

  componentWillReceiveProps(nextProps){
  if(nextProps.authenticated){
    this.props.history.push('/dashboard');
  }else if(nextProps.logInFailMessage != null  && nextProps.logInFailMessage != ""){
    alert(nextProps.logInFailMessage);
    this.props.dispatch(setMessageFail());
  }
}



  render() {

    return (
      <div className = "adminpanelbackground">
              <div className = "loginFormDiv">
              <img src={require("./logo.png")} className = "adminsimg" /> 
                  <div className= " administrator">ADMINISTRATOR</div>
                  <div className = "access">Please sign in to get access</div>
    
                  <div className= "loginForm">
                    <input type="text" className = "loginInputtext" placeholder="Email"  name="email" value={this.state.email} onChange={this.onChange}/><br/>
                    <input type="password" className = "loginInputtext" placeholder="Password" name="password" value={this.state.password} onChange={this.onChange} /><br/>
                    <br/>
                   <div className = "btnlogin"> <button  className="loginbtn" onClick={this.login} >LogIn</button></div><br/>
    
                  </div>
    
                </div>
                  </div>  

            
    );
  }
}


const  mapStateToProps =(state) =>{
  return {
       status : state.login.success,
       authenticated : state.login.authenticated,
       logInFailMessage : state.login.message,
  }
}

export default  connect(mapStateToProps)(LogIn);



// WEBPACK FOOTER //
// ./src/pages/login/index.js